import { render } from "./ModalTantou.vue?vue&type=template&id=0443c6ba&scoped=true"
import script from "./ModalTantou.vue?vue&type=script&lang=js"
export * from "./ModalTantou.vue?vue&type=script&lang=js"

import "./ModalTantou.vue?vue&type=style&index=0&id=0443c6ba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0443c6ba"]])

export default __exports__